import AnnualProcurementPlanDetails from "@containers/Procurement/AnnualProcurementPlanDetails";
import VendorsList from "@containers/Procurement/VendorsList";
import CommitteeList from "@containers/Procurement/CommitteeList";
import AddNewVendors from "@containers/Procurement/CreateVendor";
import AddNewPackage from "@containers/Procurement/CreatePackage";
import AddNewAnnualProcurementPlan from "@containers/Procurement/CreateAnnualProcurementPlan";

import NoMatch from "@containers/no-match";

import { ROUTES } from "@constants/routes";
import { RouteType } from "./types";
import ProcurementDemandList from "@containers/Procurement/ProcurementDemandList";
import CreateProcurementDemand from "@containers/Procurement/CreateProcurementDemand";
import CreateProcurementList from "@containers/Procurement/ProcurementList";

import AnnualProcurementPlan from "@containers/Procurement/AnnualProcurementPlan";
import CreateNewCommittee from "@containers/Procurement/CreateCommitee";
import CreateProcurementDetails from "@containers/Procurement/CreateProcurementDetails";
const { PROCUREMENT, CREATE, DETAILS, UPDATE, ID, ID_2 } = ROUTES;

const { ANNUAL_PROCUREMENT_PLAN, PROCUREMENTS, DEMANDS, VENDORS, COMMITTEE } =
  PROCUREMENT;

export const ProcurementRoutes: RouteType[] = [
  //ANNUAL PROCUREMENT PLAN
  {
    id: "procurement_details",
    path: ANNUAL_PROCUREMENT_PLAN,
    children: [
      {
        id: "annualProcurementPlan_list",
        index: true,
        element: <AnnualProcurementPlan />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_STORE_IN_CHARGE",
        },
      },

      {
        id: "create_annualProcurementPlan_list",
        path: CREATE,
        element: <AddNewAnnualProcurementPlan />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },
      {
        id: "edit_annualProcurementPlan_list",
        path: ID,
        element: <AddNewAnnualProcurementPlan />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },

      {
        id: "details_annualProcurementPlan",
        path: DETAILS,
        children: [
          {
            id: "details_annualProcurementPlan_noMatch",
            index: true,
            element: <NoMatch />,
            redirection: <NoMatch />,
            permissions: {
              auth: ["token"],
            },
          },
          {
            id: "details_annualProcurementPlan_list",
            path: ID,
            children: [
              {
                id: "details_annualProcurementPlan_package",
                index: true,
                element: <AnnualProcurementPlanDetails />,
                redirection: <NoMatch />,
                permissions: {
                  auth: ["token"],
                  access: "PROCUREMENT_STORE_IN_CHARGE",
                },
              },
              {
                id: "details_annualProcurementPlan_package_create",
                path: CREATE,
                element: <AddNewPackage />,
                redirection: <NoMatch />,
                permissions: {
                  auth: ["token"],
                  access: "PROCUREMENT_HR",
                },
              },
              {
                id: "details_annualProcurementPlan_package_edit",
                path: ID_2,
                element: <AddNewPackage />,
                redirection: <NoMatch />,
                permissions: {
                  auth: ["token"],
                },
              },
            ],
          },
        ],
      },
    ],
  },

  // VENDOR MODULE
  {
    id: "vendor_module",
    path: VENDORS,
    children: [
      {
        id: "vendor_list",
        index: true,
        element: <VendorsList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },
      {
        id: "edit_vendor",
        path: ID,
        element: <AddNewVendors />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },
      {
        id: "add_vendor",
        path: CREATE,
        element: <AddNewVendors />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },
    ],
  },

  // COMMITTEE MODULE
  {
    id: "committee_module",
    path: COMMITTEE,
    children: [
      {
        id: "committee_list",
        index: true,
        element: <CommitteeList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },
      {
        id: "create_committee_list",
        path: ID,
        element: <CreateNewCommittee />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },
      {
        id: "create_committee_list",
        path: CREATE,
        element: <CreateNewCommittee />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },
    ],
  },

  // DEMAND MODULE
  {
    id: "demand_module",
    path: DEMANDS,
    children: [
      {
        id: "demand_list",
        index: true,
        element: <ProcurementDemandList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_STORE_IN_CHARGE",
        },
      },
      {
        id: "demand_create",
        path: CREATE,
        element: <CreateProcurementDemand />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_STORE_IN_CHARGE",
        },
      },
      {
        id: "demand_details",
        path: ID,
        element: <CreateProcurementDemand />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_STORE_IN_CHARGE",
        },
      },
    ],
  },

  // PROCUREMENT MODULE
  {
    id: "procurement_module",
    path: PROCUREMENTS,
    children: [
      {
        id: "procurement_list",
        index: true,
        element: <CreateProcurementList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_STORE_IN_CHARGE",
        },
      },
      {
        id: "procurement_create",
        path: CREATE,
        element: <CreateProcurementDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_HR",
        },
      },
      {
        id: "procurement_details",
        path: ID,
        element: <CreateProcurementDetails />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
          access: "PROCUREMENT_STORE_IN_CHARGE",
        },
      },
    ],
  },
];
